import { render, staticRenderFns } from "./OpeningItem.vue?vue&type=template&id=44e5eabc&scoped=true"
import script from "./OpeningItem.vue?vue&type=script&lang=js"
export * from "./OpeningItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e5eabc",
  null
  
)

export default component.exports